import React, {useEffect} from "react";
import { Script } from "gatsby";

function ReviewCarousel() {
  useEffect(() => {
    if (window?.yotpoWidgetsContainer) {
      window.yotpoWidgetsContainer.initWidgets();
    }
  }, []);
  return (
      <div className="w-full px-5 box-border">
        <Script
            src="https://cdn-widgetsrepository.yotpo.com/v1/loader/9g8Gx8WgA0n3q0e5AylMChz16K3lt1wNxp5Sxrak"
        ></Script>
        <div className="w-full px-5 xl:px-[90px] box-border md:mt-10">
          <div className="flex flex-wrap justify-between">
            <h2 className="md:min-w-[370px] w-max mt-5 text-center lg:text-left text-3xl md:text-4xl font-bold mb-[10px] lg:mb-5">Customer
              Reviews & Ratings</h2>
        </div>
      </div>
  <div className="yotpo-widget-instance"
       data-yotpo-instance-id="475339"
  ></div>
</div>
)
  ;
}

export default React.memo(ReviewCarousel);
